
import api from '../interceptors/interceptor';
import { API_ROUTES } from '../constants/apiRoutes';

export class RoutingRepository {
  private static instance: RoutingRepository;

  /**
   * Singleton pattern - ensure only one instance exists
   */
  public static getInstance(): RoutingRepository {
    if (!RoutingRepository.instance) {
      RoutingRepository.instance = new RoutingRepository();
    }
    return RoutingRepository.instance;
  }

  public async addRoute(payload: any): Promise<any> {
    return (await api.post(API_ROUTES.ROUTER_ADD_ROUTE, payload))?.data;
  }

  public async getRoutes(): Promise<any> {
    return (await api.get(API_ROUTES.GET_ROUTER))?.data;
  }

  public async getRouteByInstanceId(instanceId: string): Promise<any> {
    return (await api.get(API_ROUTES.ROUTER_ROUTES(instanceId)))?.data;
  }

}
